import { render, staticRenderFns } from "./StockEdit.vue?vue&type=template&id=4d997790&scoped=true"
import script from "./StockEdit.vue?vue&type=script&lang=js"
export * from "./StockEdit.vue?vue&type=script&lang=js"
import style0 from "./StockEdit.vue?vue&type=style&index=0&id=4d997790&prod&lang=scss&scoped=true"
import style1 from "./StockEdit.vue?vue&type=style&index=1&id=4d997790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d997790",
  null
  
)

export default component.exports